import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT, STATUS_GROUPS } from "../const";

export const statusContains = async (search) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/status/bynamecontaining`,
      search,
    );
    console.log(response);
    return response.data.map((item) => ({
      key: item.id,
      title: item.text,
      value: item.value,
    }));
  } catch (e) {
    console.error(e);
  }
};

export const statusByContext = async (context = STATUS_GROUPS.ALL) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/status/${context}`,
    );
    return response.data.map((item) => ({
      key: item.id,
      text: item.text,
      value: item.value,
    }));
  } catch (e) {
    console.error(e);
  }
};

export const statusIdsByContexts = async (contexts = []) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/status/ids-by-group`,
      contexts,
    );
    return response.data;
  } catch (e) {
    console.error(e);
    return {};
  }
};

export const statusManagerById = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/status-manager/${id}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const StatusById = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/status/text-value/${id}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};
